import React from "react";

export default function Ornament({ label }) {
  return (
    <div className="rule-ornament my-6">
      {label && (
        <span className="press-title italic text-ink/70 text-sm tracking-widest uppercase">
          {label}
        </span>
      )}
    </div>
  );
}
